import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TimePicker } from 'antd';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import Select from 'react-select';

import { Button, Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';

import { GET_REASON_BY_ACTIONS, GET_REJECT_SLOT_OPTIONS_V2, REJECT_SLOT, REJECT_SLOT_EMPTY } from '../../../../../../../store/actions';

const RejectBooking = ({ onClose, currentSelectedBooking }) => {
  const dispatch = useDispatch();

  const [selectedRemark, setSelectedRemark] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [allDatesWithTime, setAllDatesWithTime] = useState([]);

  const [availableDates, setAvailableDates] = useState([]);
  const [slotOptions, setSlotOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [confirmationNumber, setConfirmationNumber] = useState('');

  const [selectedSpecificSlotTime, setSelectedSpecificSlotTime] = useState(null);

  const { rejectSlotOptions, rejectSlotOptionsLoading, rejectBookingLoading, rejectBooking, remarksList } = useSelector(state => ({
    rejectSlotOptions: state?.GetRejectSlotOptionsV2?.data,
    rejectSlotOptionsLoading: state?.GetRejectSlotOptions?.loading,
    rejectBookingLoading: state?.RejectSlot?.loading,
    rejectBooking: state?.RejectSlot?.data,
    remarksList: state?.GetReasonByActions?.data,
  }));

  console.log('rejectSlotOptions-v2', rejectSlotOptions);

  useEffect(() => {
    if (currentSelectedBooking?.id) {
      dispatch({
        type: GET_REASON_BY_ACTIONS,
        payload: {
          urlParams: {
            booking_type: currentSelectedBooking?.bookingType || '',
            booking_status: currentSelectedBooking?.bookingStatus,
            action: 'reject-slot',
            is_active: true,
            page_size: 50,
            page_index: 0,
          },
        },
      });
      dispatch({
        type: GET_REJECT_SLOT_OPTIONS_V2,
        payload: {
          data: {
            booking_id: currentSelectedBooking?.id,
          },
        },
      });
    }
  }, [currentSelectedBooking, dispatch]);

  const transformSlots = data => {
    const grouped = {};
    data?.slots?.forEach(slot => {
      const { slotDate, slotId, slotTime, remainingQuota, isActive } = slot;
      if (!grouped[slotDate]) grouped[slotDate] = [];
      grouped[slotDate].push({ slotId, slots: slotTime, remainingQuota, isActive });
    });

    return Object.keys(grouped).map(date => ({
      date: date,
      slots: grouped[date],
    }));
  };

  useEffect(() => {
    if (rejectSlotOptions !== null) {
      const transformDates = transformSlots(rejectSlotOptions);
      const dates = transformDates?.map(slot => slot.date);
      setAllDatesWithTime(transformDates);
      setAvailableDates(dates ?? []);
    }
  }, [rejectSlotOptions]);

  useEffect(() => {
    if (rejectBooking !== null) {
      dispatch({
        type: REJECT_SLOT_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: REJECT_SLOT_EMPTY,
      });
    };
  }, [rejectBooking]);

  useEffect(() => {
    if (selectedDate) {
      const dateStr = moment(selectedDate).format('YYYY-MM-DD');
      const slotObj = allDatesWithTime?.find(item => item.date === dateStr);

      const options = slotObj
        ? slotObj.slots.map(slot => ({
            label: slot?.slots,
            value: slot?.slots,
            slot_id: slot?.slotId,
            data: slot,
          }))
        : [];

      setSlotOptions(options);
      setSelectedSlot(null); // Reset slot when date changes
    }
  }, [selectedDate, rejectSlotOptions]);

  console.log('Selected Slot', selectedSlot, availableDates);

  const handleSubmit = () => {
    const newErrors = {};
    if (!selectedRemark) newErrors['reason_id'] = 'Remark is required';
    // if (!selectedDate) newErrors['date'] = 'Date is required';
    // if (!selectedSlot) newErrors['slot'] = 'Slot is required';
    if (!selectedSpecificSlotTime) newErrors['slot'] = 'Slot is required';

    setErrors(newErrors);

    console.log(
      'reject slot submission',
      {
        booking_id: currentSelectedBooking?.id,
        reason_id: selectedRemark.value,
        // slot_date: moment(selectedDate).format('YYYY-MM-DD'),
        slot_date: availableDates?.[0],
        slot_time: selectedSpecificSlotTime ? selectedSpecificSlotTime.format('HH:mm') : null,
        slot_id: '',
        // slot_time: selectedSlot.value,
      },
      Object.keys(newErrors).length,
    );

    if (Object.keys(newErrors).length === 0) {
      dispatch({
        type: REJECT_SLOT,
        payload: {
          data: {
            booking_id: currentSelectedBooking?.id,
            reason_id: selectedRemark.value,
            // slot_date: moment(selectedDate).format('YYYY-MM-DD'),
            confirmation_number: confirmationNumber,
            slot_date: availableDates?.[0],
            slot_time: selectedSpecificSlotTime ? selectedSpecificSlotTime.format('HH:mm') : null,
            slot_id: '',
            // slot_time: selectedSlot.value,
          },
        },
      });
    }
  };

  const { disabledHours, disabledMinutes } = useMemo(() => {
    if (rejectSlotOptions?.slots.length > 0) {
      return getDisabledTimeRange(rejectSlotOptions?.slot_range_from, rejectSlotOptions?.slot_range_to);
    } else {
      return { disabledHours: () => [], disabledMinutes: () => [] };
    }

    // return { disabledHours: () => [], disabledMinutes: () => [] };
  }, [rejectSlotOptions]);

  return (
    <Modal isOpen={true} size="md">
      <ModalHeader toggle={onClose}>
        <h4>Reject Booking</h4>
      </ModalHeader>

      <ModalBody>
        <Row>
          <Col md={12} className="mt-3 mb-3">
            <Label className="form-label">Remarks</Label>
            <Select
              id="decline-remarks"
              name="decline-remarks"
              placeholder="Select reason to modify the booking"
              value={selectedRemark}
              options={remarksList?.reasons?.map(remark => ({
                label: remark.reason,
                value: remark.id,
              }))}
              onChange={data => {
                setSelectedRemark(data);
              }}
            />
            {errors['reason_id'] && <div className="text-danger">{errors['reason_id']}</div>}
          </Col>

          <p className="fw-medium m-0">Next Available Slots</p>

          <Col md={6} className="mt-3 mb-3">
            <div className="area_expandable">
              <Flatpickr
                className={`form-control ${availableDates?.[0] && 'disabled'}`}
                options={{
                  dateFormat: 'Y-m-d',
                  mode: 'single',
                  enable: availableDates,
                }}
                // onChange={([date]) => setSelectedDate(date)}
                // value={selectedDate}
                value={selectedDate ?? availableDates?.[0]}
                onChange={([date]) => setSelectedDate(date)}
                disabled={availableDates?.[0]}
              />
              <span className="icon_calendar_v2_reject">
                <i className="ri-calendar-2-line"></i>
              </span>
              {errors['date'] && <div className="text-danger">{errors['date']}</div>}
            </div>
          </Col>

          <Col md={6} className="mt-3 mb-3">
            {/* <Select
              id="decline-slot"
              name="decline-slot"
              placeholder="Select available slot"
              value={selectedSlot}
              options={slotOptions}
              onChange={data => setSelectedSlot(data)}
              isDisabled={!selectedDate}
            /> */}
            <TimePicker
              className="w-100"
              use12Hours
              format="h:mm a"
              disabledHours={disabledHours}
              disabledMinutes={disabledMinutes}
              value={selectedSpecificSlotTime}
              onChange={time => {
                setSelectedSlot(rejectSlotOptions?.results?.[0]);
                setSelectedSpecificSlotTime(time);
              }}
            />
            {errors['slot'] && <div className="text-danger">{errors['slot']}</div>}
          </Col>

          <Col md={12} className="mt-3 mb-3">
            <Label for="confirmationNumber">
              <strong>Confirmation Number</strong>
            </Label>
            <Input
              type="text"
              id="confirmationNumber"
              value={confirmationNumber}
              onChange={e => {
                const input = e.target.value;
                setConfirmationNumber(input); // no formatting or restriction
              }}
              placeholder="Enter confirmation number"
            />
          </Col>
        </Row>

        <Col md={12} className="mt-3 mb-4 text-center">
          {!rejectBookingLoading ? (
            <Button color="primary" style={{ fontSize: '14px', width: '200px' }} onClick={handleSubmit}>
              Reject Booking
            </Button>
          ) : (
            <Button color="primary" style={{ fontSize: '14px', width: '200px' }}>
              <Spinner className="btn-replacer-spinner" />
            </Button>
          )}
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default RejectBooking;

function getDisabledTimeRange(startTime, endTime) {
  if (!startTime || !endTime) {
    // no restrictions → allow everything
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  }

  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  const startHour = start.hour();
  const startMinute = start.minute();
  const endHour = end.hour();
  const endMinute = end.minute();

  const disabledHours = () => {
    const disabled = [];
    for (let i = 0; i < 24; i++) {
      if (i < startHour || i > endHour) {
        disabled.push(i);
      }
    }
    return disabled;
  };

  const disabledMinutes = selectedHour => {
    let minutes = [];
    if (selectedHour === startHour) {
      // disable before startMinute
      minutes = minutes.concat(Array.from({ length: startMinute }, (_, i) => i));
    }
    if (selectedHour === endHour) {
      // disable after endMinute
      minutes = minutes.concat(Array.from({ length: 59 - endMinute }, (_, i) => i + endMinute + 1));
    }
    return minutes;
  };

  return { disabledHours, disabledMinutes };
}
